import type { ItemVersionInfo } from '@mimir/common/dto/itemVersionInfo';

export function getVersionsSortedByCreatedDateDesc<T extends ItemVersionInfo>(versions: T[]) {
  return versions.sort((a, b) => {
    if (a.versionCreatedOn < b.versionCreatedOn) return 1;
    if (a.versionCreatedOn > b.versionCreatedOn) return -1;
    return 0;
  });
}

